import { RETURN } from '@web-platform/shared-universal-constants/src/tripTypes';
import { GLOBAL } from 'saddlebag-browser';

import { convertFromDashedTripType } from './tripType';

import type { TripType } from '@web-platform/shared-universal-constants/src/tripTypes';
import type { RawSearchParams } from '@web-platform/shared-universal-types/src/documentStateAcorn';

export const getIsMultiDestination = (): TripType => {
  const $window = GLOBAL.getWindow();
  if (!$window?.__internal) return RETURN;

  const {
    searchParams: rawSearchParam,
  }: {
    searchParams: RawSearchParams;
  } = $window.__internal;

  if (!rawSearchParam) return RETURN;
  return rawSearchParam.tripType ? convertFromDashedTripType(rawSearchParam.tripType) : RETURN;
};
